// Static copy and table-filter options for the Team Review page. Logic lives in
// _schedule-team-review-page-service.ts; the page component only wires these up.

export const EMPLOYMENT_FILTER_OPTIONS = [
  { text: 'Core', value: 'CORE' },
  { text: 'Agency', value: 'AGENCY' },
];

export const STATUS_FILTER_OPTIONS = [
  { text: 'Active', value: 'active' },
  { text: 'Inactive', value: 'inactive' },
];

// Mirrors the LoadBalancingScheduleShiftPreference enum (EITHER renders as "Flexible").
export const SHIFT_PREFERENCE_FILTER_OPTIONS = [
  { text: 'Day', value: 'DAY' },
  { text: 'Night', value: 'NIGHT' },
  { text: 'Flexible', value: 'EITHER' },
];

export const SHIFT_PATTERN_FILTER_OPTIONS = [
  { text: 'Consecutive', value: 'CONSECUTIVE' },
  { text: 'Non-consecutive', value: 'NON_CONSECUTIVE' },
  { text: 'No Shift Pattern', value: 'NO_PREFERENCE' },
];

// FTE hours = 40 (full-time weekly hours) × FTE% × period weeks (see
// LoadBalancingWorkerTerm.fteHours), so they're non-negative — the range filter's
// floor is 0. When the user leaves a side blank it defaults to the full span: 0 …
// a full-time worker's hours over a standard six-week period (40 × 6 = 240h).
export const FTE_HOURS_MIN = 0;
export const FTE_HOURS_MAX_DEFAULT = 40 * 6;

// ── Schedule-generation loading screen (WORK-6302) ──────────────────────────────────

// Heading + narrated steps for the full-screen loader shown after "Confirm & Generate".
// Copy is generic (not mapped to backend run states, per MVP) and mirrors the component's
// story so the wired flow matches what was designed.
export const SCHEDULE_GENERATION_LOADER_TITLE = 'Creating your schedule';

export const SCHEDULE_GENERATION_STEPS = [
  { key: 'review-team', label: 'Reviewing your team' },
  { key: 'match-staff', label: 'Matching staff to open shifts' },
  { key: 'charge-coverage', label: 'Ensuring charge coverage' },
  { key: 'fte-targets', label: 'Balancing schedules to FTE targets' },
  { key: 'staffing-requirements', label: 'Checking staffing requirements' },
  { key: 'finalize', label: 'Getting your schedule ready' },
];

// How long each loader step holds before the next highlights, in ms. Short enough that a few
// steps visibly cycle during a typical generation; the component holds the last step until the
// page dismisses, so this never races the real run.
export const SCHEDULE_GENERATION_STEP_INTERVAL_MS = 3_500;

// Toast when the run transitions to `failed`. A run-state failure carries no ApolloError, so
// this is fixed copy (matching regenerateErrorMessage's default) rather than that mapper. The
// user stays on the page and can retry via Confirm.
export const SCHEDULE_GENERATION_FAILED_MESSAGE =
  'We could not generate the schedule. Please try again.';

// Toast when generation exceeds the slow timeout: we navigate to the dashboard, where the run
// keeps surfacing as it finishes. Reassuring copy — nothing has failed.
export const SCHEDULE_GENERATION_SLOW_MESSAGE =
  'Your schedule is taking longer than expected. We’ve taken you to the dashboard — it will appear there once it’s ready.';
